import { EventGeofencing } from 'utils/event'
import { EventGroup } from '../Event/interfaces/interfaceCreateEditEvent'

export enum LocationType {
  Event = 'Event', // TODO added by an event?
  Public = 'Public', // TODO has an associated check-in opportunity?
  Private = 'Private', //TODO just part of the address list
}

export enum LocationAddressType {
  AddressAndCoords = 'address-and-coords',
  PlusCode = 'plus-code',
  CustomTextOnly = 'custom-text-only',
}

export interface OrganizationLocation {
  id: number
  organizationId: number
  locationId: number
  order: number | null
  name: string | null
  line1: string | null
  line2: string | null
  city: string | null
  county: string | null
  state: string | null
  zipCode: string | null
  countryCode: string | null
  geofencing: EventGeofencing
  type: LocationType
  addressType?: LocationAddressType
  locationAddressType?: LocationAddressType //TODO make this non-optional
  encodedOccurrence?: string | null
  opportunityOccurrenceId?: number | null
  description?: string | null
  startsAt?: string
  endsAt?: string | null
  visibilityGroups?: EventGroup[]
  onboardingGroups?: EventGroup[]
  locationDetails?: string | null
  startDate?: Date | null
  endDate?: Date | null
  roleIds: []
  autoCheckoutTimes?: string[]
}

export interface OrganizationLocationReporting extends OrganizationLocation {
  timesUsedActive: number
  timesUsedTotal: number
  locationIsAddress: boolean
  locationAddressType?: LocationAddressType
  visibility: 'Public' | 'Private'
}

export interface OrganizationLocationPayload {
  id?: number
  name?: string | null
  line1?: string | null
  line2?: string | null
  city?: string | null
  county?: string | null
  state?: string | null
  zipCode?: string | null
  countryCode?: string | null
  geofencing?: EventGeofencing
  locationDetails?: string | null
  locationAddressType?: LocationAddressType
  locationIsAddress?: boolean
  autoCheckoutTimes?: string[]
}
